module.exports = __webpack_public_path__ + "img/done.0d6db30d.png";